import type { ContactOrderStepPatch } from "../../../_logic/communication-plan-table-contract"

type RecordValue = Record<string, unknown>

const isRecord = (value: unknown): value is RecordValue =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value)

const valuesMatch = (expected: unknown, actual: unknown): boolean => {
  if (Array.isArray(expected)) {
    if (!Array.isArray(actual) || expected.length !== actual.length) return false

    return expected.every((entry, index) => valuesMatch(entry, actual[index]))
  }

  if (isRecord(expected)) {
    if (!isRecord(actual)) return false

    return Object.entries(expected).every(([key, value]) => valuesMatch(value, actual[key]))
  }

  return Object.is(expected, actual)
}

export const stepPatchMatchesLiveStep = (
  patch: ContactOrderStepPatch,
  liveStep: RecordValue | null | undefined,
) => {
  if (!liveStep) return false

  return Object.entries(patch).every(([key, value]) => valuesMatch(value, liveStep[key]))
}
